// The document's own two rules — the half no component can reach.
//
// **Not `CssBaseline`.** Same argument `theme.ts` makes: `index.html` sets the
// shell's background, height and overflow for a full-window canvas and
// baseline would reset all three to its own idea of a page. What is actually
// wanted is the body's face and colour, and form controls inheriting it —
// browsers default `input`/`select`/`textarea` to a 13px system face, so a
// `Field` that does not say otherwise arrives in the wrong font.
//
// **No `* { box-sizing: border-box }`.** The render layer and the board
// overlays measure content boxes; a global switch would move every one of them
// by its own border. Primitives that want it say so themselves (`Field`).

import { GlobalStyles } from "@mui/material";
import { useTheme } from "@mui/material/styles";

export function KitGlobals() {
  const theme = useTheme();
  return (
    <GlobalStyles
      styles={{
        body: {
          margin: 0,
          fontFamily: theme.kit.font.body,
          color: theme.kit.color.ink,
          background: theme.kit.color.ground
        },
        "button, input, select, textarea": { font: "inherit" }
      }}
    />
  );
}
